import { useCallback, useState } from 'react';

import { IChannel, PROTOCOL } from '@/entities/channel';

export function useChannelsDialogs() {
  const [openPendingChannelDialog, setOpenPendingChannelDialog] =
    useState(false);
  const [openTgBotDialog, setOpenTgBotDialog] = useState(false);
  const [openTgPersonalDialog, setOpenTgPersonalDialog] = useState(false);
  const [openWabaDialog, setOpenWabaDialog] = useState(false);
  const [openWhatsAppPersonalDialog, setOpenWhatsAppPersonalDialog] =
    useState(false);
  const [openMaxDialog, setOpenMaxDialog] = useState(false);
  const [openMaxPersonalDialog, setOpenMaxPersonalDialog] = useState(false);
  const [openAvitoDialog, setOpenAvitoDialog] = useState(false);
  const [openWildberriesDialog, setOpenWildberriesDialog] = useState(false);
  const [openOzonDialog, setOpenOzonDialog] = useState(false);
  const [openVkDialog, setOpenVkDialog] = useState(false);

  // useCallback необходим, так как функция используется в зависимостях useEffect
  const openAuthorizationDialogByProtocol = useCallback(
    ({ protocol }: IChannel) => {
      if (protocol === PROTOCOL.TELEGRAM_BOT) {
        setOpenTgBotDialog(true);
      }
      if (protocol === PROTOCOL.WHATSAPP_GRAY) {
        setOpenWhatsAppPersonalDialog(true);
      }
      if (protocol === PROTOCOL.TELEGRAM_PERSONAL) {
        setOpenTgPersonalDialog(true);
      }
      if (protocol === PROTOCOL.MAX) {
        setOpenMaxDialog(true);
      }
      if (protocol === PROTOCOL.MAX_PERSONAL) {
        setOpenMaxPersonalDialog(true);
      }
      if (protocol === PROTOCOL.AVITO) {
        setOpenAvitoDialog(true);
      }
      if (protocol === PROTOCOL.WILDBERRIES) {
        setOpenWildberriesDialog(true);
      }
      if (protocol === PROTOCOL.OZON) {
        setOpenOzonDialog(true);
      }
      if (protocol === PROTOCOL.VK) {
        setOpenVkDialog(true);
      }
    },
    [
      setOpenTgBotDialog,
      setOpenTgPersonalDialog,
      setOpenWhatsAppPersonalDialog,
      setOpenMaxDialog,
      setOpenMaxPersonalDialog,
      setOpenAvitoDialog,
      setOpenWildberriesDialog,
      setOpenOzonDialog,
      setOpenVkDialog,
    ]
  );

  return {
    openPendingChannelDialog,
    setOpenPendingChannelDialog,
    openTgBotDialog,
    setOpenTgBotDialog,
    openTgPersonalDialog,
    setOpenTgPersonalDialog,
    openWabaDialog,
    setOpenWabaDialog,
    openWhatsAppPersonalDialog,
    setOpenWhatsAppPersonalDialog,
    openMaxDialog,
    setOpenMaxDialog,
    openMaxPersonalDialog,
    setOpenMaxPersonalDialog,
    openAvitoDialog,
    setOpenAvitoDialog,
    openWildberriesDialog,
    setOpenWildberriesDialog,
    openOzonDialog,
    setOpenOzonDialog,
    openVkDialog,
    setOpenVkDialog,
    openAuthorizationDialogByProtocol,
  };
}
